export default {"src":"/_next/static/media/me.8b92e4d2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};